import { connect } from 'react-redux';

import RevenueMainOptionsBar from '../../../../../components/revenue/RevenueMainOptionsBar';
import {
  setRevenueGroupColumn,
  setRevenueSplitColumn,
  setRevenueType,
  setAmountField,
} from '../../../../../actions/dashboards/revenue';
import {
  getMetainf,
  getDashboardsRevenueGroupColumn,
  getDashboardsRevenueQueryType,
  getDashboardsRevenueSplitColumn,
  getDashboardsRevenueAmountField,
  getDashboardsRevenueAmountFields,
} from '../../../../../reducers/analyticsApp';
import { commonEvents } from '../../../../../constants/event';
import { revenueQueryTypes } from '../../../../../constants/revenue';

const mapStateToProps = (state, { unit }) => {
  const revenueType = getDashboardsRevenueQueryType(state, unit.id);

  return {
    metainf:
      revenueType === revenueQueryTypes.ARPU || revenueType === revenueQueryTypes.PAYERS
        ? getMetainf(state)
        : getMetainf(state, commonEvents.PAYMENT),
    groupColumn: getDashboardsRevenueGroupColumn(state, unit.id),
    splitColumn: getDashboardsRevenueSplitColumn(state, unit.id),
    queryType: getDashboardsRevenueQueryType(state, unit.id),
    field: getDashboardsRevenueAmountField(state, unit.id),
    fields: getDashboardsRevenueAmountFields(state, unit.id),
  };
};

const mapDispatchToProps = (dispatch, { unit }) => ({
  onChangeGroupColumn: (value) => dispatch(setRevenueGroupColumn(unit.id, value)),
  onChangeSplitColumn: (value) => dispatch(setRevenueSplitColumn(unit.id, value)),
  onChangeQueryType: (value) => dispatch(setRevenueType(unit.id, value)),
  onChangeAmount: (value) => dispatch(setAmountField(unit.id, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RevenueMainOptionsBar);
